export class Validators {
   private static readonly urlFormatExp = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
   private static readonly salaryFormat = /^\d*\.?\d+$/;

   public static required(val: string | unknown[] | null | undefined | number): string {
      if (typeof val === 'string') {
         if (val === '') {
            return "Поле обов'язкове";
         } else {
            return '';
         }
      }

      if (Array.isArray(val)) {
         if (val.length === 0) {
            return "Поле обов'язкове";
         }
         return '';
      }

      if (typeof val === 'number') {
         return '';
      }

      if (val === null || val === undefined) {
         return "Поле обов'язкове";
      } else {
         return '';
      }
   }

   public static urlFormat(val: string): string {
      if (val && !Validators.urlFormatExp.test(val)) {
         return 'Будь ласка, введіть дійсний URL вебсайту компанії';
      }
      return '';
   }

   public static salaryNumeric(val: string): string {
      if (val && !Validators.salaryFormat.test(val)) {
         return ' Має бути число';
      }
      return '';
   }
}
